import React, { ChangeEvent } from 'react';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import RefreshIcon from '@/assets/images/refresh-icon.svg';
import CrossIcon from '@/assets/images/x-close.svg';
import useWebAlias from '@/helpers/hooks/useWebalias';
import { getRelativeUrlForInternalDomains } from '@/helpers/utils/urlHelpers';
import { useAppContext } from '@/layouts/AppProvider';

import { useSearchContext } from './SearchBarProvider';

const RecentSearchesContainer = () => {
  const router = useRouter();
  const { isBackOffice } = useAppContext();
  const { webalias, generateURL } = useWebAlias();
  const { onSearchChange, navigateToSearchPage, getInputProps, setSearchBarFocused, blurInputFields } =
    useSearchContext();
  const { onChange } = getInputProps({
    inputElement: null,
  });
  const { recentSearchList, deleteSearchQueryInRecentSearches } = useSearchContext();

  const handleSearchTageClick = (searchText: string) => {
    const target = { value: searchText };
    const event = { target, currentTarget: target, relatedTarget: target };
    onChange(event as unknown as Event);
    onSearchChange(event as unknown as ChangeEvent<HTMLInputElement>);
    navigateToSearchPage(searchText);
    setSearchBarFocused(false);
    blurInputFields();
  };

  if (recentSearchList.length === 0) return null;

  return (
    <>
      <h3 className="v2-font-medium v2-font-sweet-sans-pro-medium v2-text-[#101828] v2-text-sm v2-mb-[12px]">
        Recent Searches
      </h3>
      <div className="v2-mb-[24px] v2-flex v2-flex-col v2-gap-2">
        {recentSearchList.map(search => {
          if (search.searchText)
            return (
              <div className="v2-flex v2-gap-[8px] v2-items-center" key={search.searchItemKey}>
                <Image
                  src={RefreshIcon}
                  alt=""
                  width={16}
                  height={16}
                  role="button"
                  onClick={e => {
                    e.preventDefault();
                    console.log(search, 'search clicked');
                    if (search.isLink && search.link) {
                      return router.push(
                        getRelativeUrlForInternalDomains(search.link, isBackOffice).replace('{0}', webalias)
                      );
                    }
                    handleSearchTageClick(search.searchText);
                  }}
                />
                <p
                  className="v2-font-normal v2-font-sweet-sans-pro v2-text-[#101828] v2-text-sm v2-cursor-pointer"
                  role="button"
                  onClick={e => {
                    e.preventDefault();
                    console.log(search, 'search clicked');
                    if (search.isLink && search.link) {
                      return router.push(
                        getRelativeUrlForInternalDomains(search.link, isBackOffice).replace('{0}', webalias)
                      );
                    }
                    handleSearchTageClick(search.searchText);
                  }}
                >
                  {search.searchText}
                </p>
                <Image
                  src={CrossIcon}
                  alt=""
                  width={16}
                  height={16}
                  role="button"
                  className="v2-cursor-pointer v2-ml-auto"
                  onClick={() => deleteSearchQueryInRecentSearches(search.searchItemKey)}
                />
              </div>
            );
        })}
      </div>
    </>
  );
};

export default RecentSearchesContainer;
